import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, name, type, url, imageUrl }) => {
  return (
    <Helmet>
      { /* Standard metadata tags */ }
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='author' content={name} />
      <meta name='keywords' content="Gayatri Duse, Developer Portfolio, Smart India Hackathon Winner, NASA Space Apps Finalist, Full Stack Developer, Nashik Developer, React Developer" />
      { /* End standard metadata tags */ }

      { /* Facebook tags */ }
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      { /* End Facebook tags */ }

      { /* Twitter tags */ }
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content={imageUrl ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      { /* End Twitter tags */ }

      { /* Schema.org JSON-LD */ }
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": name,
          "url": url,
          "jobTitle": "Developer",
          "sameAs": [
            "https://github.com/Gayatrii4506",
            "https://www.linkedin.com/in/gayatri-duse/"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
